import React from 'react';
import { useNavigate } from 'react-router-dom';

const SupportPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <button
            onClick={() => navigate('/')}
            className="bg-[#04b53a] text-white px-4 py-2 rounded hover:bg-[#039431] transition-colors"
          >
            Return to Cards
          </button>
        </div>
        
        <div className="bg-white rounded-lg shadow p-6">
          <h1 className="text-2xl font-semibold text-gray-900 mb-4">
            Support
          </h1>
          <p className="text-gray-600 mb-4">
            Have questions about the app or suggestions for new features? We'd love to hear from you!
          </p>
          <p className="text-gray-600">
            Please email:{' '}
            <a 
              href="mailto:josh@goinggreen.earth"
              className="text-[#04b53a] hover:underline"
            >
              josh@goinggreen.earth
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SupportPage; 